import React, { FC } from 'react';
import LanguageSelect from '../../user/language/LanguageSelect';
import UserMenu from './userMenu/UserMenu';
import { history } from '../../../history';

const Header: FC = () => {
  return (
    <>
      <header className="topbar">
        <div className="navbar-header">
          <div className="navbar-brand">
            <img
              src="https://cache.kreezee.com/home/logos/flat_original_logo_kreezee_no_border.svg"
              alt="Kreezee Sports"
              onClick={() => history.push('/')}
            />
          </div>
          <UserMenu />
          <LanguageSelect color="#424242" />
        </div>
      </header>
    </>
  );
};

export default Header;
